import React, { useMemo } from 'react';
// components
import { Table } from '../../../../components/table';
// features
import PC from '../../../permission/role-permission';
// helpers/constants
import * as G from '../../../../helpers';
// hooks
import useEditViewHook from '../../../../hooks/use-edit-view';
// feature payroll
import {
  tollTableSettings,
  driverPayrollReport,
  getDefaultReportFields,
  driverPayrollColumnSettings,
} from '../../settings/charges-table-settings';
//////////////////////////////////////////////////

const DriverPayrollsTab = (props: Object) => {
  const { maxHeight, driverPayrolls, selectChargeListItem, handleEditDriverPayroll } = props;

  const allChecked = G.isAllChecked(driverPayrolls);

  const tableSettings = {
    ...tollTableSettings,
    maxHeight,
    checkBoxCellWidth: 70,
    checkBoxCellJustifyContent: 'unset',
  };

  const actionButtons = [
    {
      iconName: 'pencil',
      action: handleEditDriverPayroll,
      permissions: [PC.DRIVER_PAYROLL_READ, PC.DRIVER_PAYROLL_WRITE, PC.DRIVER_PAYROLL_OVERWRITE_EXECUTE],
    },
  ];

  const { uiReportFields, handleOpenEditView } = useEditViewHook({
    ...props,
    report: driverPayrollReport,
    columnSettings: driverPayrollColumnSettings,
    defaultReportFields: getDefaultReportFields(driverPayrollReport),
  });

  const sortedReport = useMemo(() => (
    G.isNilOrEmpty(uiReportFields) ?
    driverPayrollReport : G.getSortedReport(uiReportFields, driverPayrollReport)
  ), [uiReportFields]);

  return (
    <Table
      showEditView={true}
      report={sortedReport}
      allChecked={allChecked}
      itemList={driverPayrolls}
      shouldUseUIFilters={true}
      useSearchableColumns={true}
      withResizableColumns={true}
      tableSettings={tableSettings}
      actionButtons={actionButtons}
      useNewTitleFilterInputs={true}
      handleClickEditOrder={handleOpenEditView}
      columnSettings={driverPayrollColumnSettings}
      filterProps={G.getFilterPropsFromColumnSettings(driverPayrollColumnSettings)}
      onOptionClick={(guid: string) => selectChargeListItem(guid, 'driverPayrolls')}
    />
  );
};

export default DriverPayrollsTab;
